export default class GetAsistenciaByIdAsistencia {
  #repository
  constructor(repository) {
    this.#repository = repository
  }

  async execute(idPersonal, idAsistencia) {
    try {
      const result = await this.#repository.getAsistenciaByIdAsistencia(idPersonal, idAsistencia)
      return result
    } catch (error) {
      console.error('Error al obtener la asistencia por ID de personal y ID de asistencia:', error)
      throw error
    }
  }
}
